import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import {
  MovementList,
  undoMovementList,
  redoMovementList,
  calculateIPRToothForNegation,
  clearRedoMovementList,
  MovementTypes,
} from "./TeethPositionHelper";
import * as THREE from "three";
import {
  Controller,
  attachmentMaterial as oldAttachmentMaterial,
} from "../Mesh";
import {
  teethMaterial,
  selectedTeethMaterial,
  lockedTeethMaterial,
} from "../Mesh";
import { getParams } from "@/helpers/getParams";
import { addEventListener, removeListenersFrom } from "@/helpers/clickManager";
import { setOrbitControlsEnabled } from "../Camera";
import { undoRef } from "./URR";
import { isLeftShiftDown } from "./TeethControls";
export let previousSelectedTooth, secondPreviousTooth;
export let isReset = false;

export function setIsReset(state) {
  isReset = state;
}

export function getIsReset(state) {
  return isReset;
}
export const attachmentMaterial = new THREE.MeshPhysicalMaterial({
  color: 0x89cff0,
  roughness: 0,
  transparent: true,
});

export const selectedAttachmentMaterial = new THREE.MeshPhysicalMaterial({
  color: 0xfcbd00,
  roughness: 0,
  transparent: false,
});
export const names = [
  "att_hbra",
  "att_vbra",
  "att_oblique",
  "att_extrusion",
  "att_biolane",
  "att_root_control",
  "att_rotational",
];
/**
 * sorted in same orders as in (names) array
 */
export let attachmentsObjects = [];

let deletedAtt,
  selectedAtt,
  attachmentIDCounter = 0;

export function setSelectedAtt(attachment) {
  if (selectedAtt) {
    if (!Controller.isRotating) {
      Controller.detach();
    }

    if (selectedAtt.name === "_att") {
      selectedAtt.material = oldAttachmentMaterial;
    } else {
      selectedAtt.material = attachmentMaterial;
    }
  }
  selectedAtt = attachment;
  if (attachment) {
    selectedAtt.material = selectedAttachmentMaterial;
    if (selectedAtt.name !== "_att" && selectedAtt.name.includes("att_")) {
      Controller.attach(attachment);
    }
  }
}
export function deleteSelectedAttachment() {
  if (selectedAtt) {
    deleteAttachment(selectedAtt);
    setSelectedAtt(null);
    return true;
  }
  return false;
}
export function setDeletedAtt(newDeletedAtt, ignoreAutoSave = false) {
  if (newDeletedAtt != deletedAtt && !ignoreAutoSave) {
    setAutoSave1();
  }
  deletedAtt = newDeletedAtt;
}

export function setAttachmentArray(attachmentArray) {
  attachmentArray1 = attachmentArray;
}
const demoTS = getParams().demoTS === "true" ? true : false;
let logs1,
  setLogs1,
  setAutoSave1,
  attachmentArray1,
  setControls3D1,
  isFilled = false;

export let isUIHold = false;

export function setIsUIHold(state) {
  isUIHold = state;
}

export function selectTooth(
  event,
  camera,
  raycaster,
  pointer,
  list,
  teethMaterial,
  scene,
  center,
  setControls3D,
  selectedTooth,
  selectedAttachmentType,
  selectedAttachment,
  numberingOverLays,
  GLBData,
  model,
  setModel,
  groupRef,
  showUpper,
  showLower,
  logs,
  setLogs,
  setScene,
  attachmentArray,
  setAutoSave,
) {
  setScene(scene);
  pointer.x = (event.clientX / window.innerWidth) * 2 - 1;
  pointer.y = -(event.clientY / window.innerHeight) * 2 + 1;
  if (event.button === 0) {
    raycaster.setFromCamera(pointer, camera.current);
    const intersects = raycaster.intersectObjects(list, false);
    let mesial;
    if (intersects.length > 0) {
      const box3 = new THREE.Box3().setFromObject(intersects[0].object);
      const point = new THREE.Vector3();
      //console.log(box3.getCenter(point));
      if (box3.getCenter(point).x < 0) {
        mesial = true;
      } else {
        mesial = false;
      }
    }
    //console.log(intersects[0].object.name.includes("u"), "UwU rar XD");
    onPointerMove(
      event,
      camera,
      raycaster,
      pointer,
      list,
      teethMaterial,
      scene,
      center,
      setControls3D,
      selectedTooth,
      selectedAttachmentType,
      selectedAttachment,
      mesial,
      GLBData,
      model,
      setModel,
      groupRef,
      logs,
      setLogs,
      attachmentArray,
      setAutoSave,
    );
  }
}
export function prepareAttachmentsUtilities(
  logs,
  setAutoSave,
  setLogs,
  setControls3D,
) {
  if (!isFilled) {
    logs1 = logs;
    setAutoSave1 = setAutoSave;
    // attachmentArray1 = attachmentArray;
    setLogs1 = setLogs;
    setControls3D1 = setControls3D;
    isFilled = true;
  }
}

// teeth selection
export function onPointerMove(
  event,
  camera,
  raycaster,
  pointer,
  list,
  teethMaterial,
  scene,
  center,
  setControls3D,
  selectedTooth,
  selectedAttachmentType,
  selectedAttachment,
  mesial,
  GLBData,
  model,
  setModel,
  groupRef,
  logs,
  setLogs,
  attachmentArray,
  setAutoSave,
) {
  if (!isFilled) {
    logs1 = logs;
    setAutoSave1 = setAutoSave;
    // attachmentArray1 = attachmentArray;
    setLogs1 = setLogs;
    selectedAttachmentType1 = selectedAttachmentType;
    setControls3D1 = setControls3D;
    selectedTooth1 = selectedTooth;
    isFilled = true;
  }
  return;
  // calculate pointer position in normalized device coordinates
  // (-1 to +1) for both components
  pointer.x = (event.clientX / window.innerWidth) * 2 - 1;
  pointer.y = -(event.clientY / window.innerHeight) * 2 + 1;

  raycaster.setFromCamera(pointer, camera.current);
  let activeList = [];
  list.forEach(item => {
    if (item.parent.visible) activeList.push(item);
  });
  const intersects = raycaster.intersectObjects(activeList, false);
  const rootControl = new THREE.Group();
  rootControl.name = "root_att";
  let tempName = "";

  if (intersects.length > 0) {
    tempName = intersects[0].object.name;

    // if (intersects[0].object.children[0].children.length > 1) {
    //   for (
    //     let attachmentIndex = 0;
    //     attachmentIndex < intersects[0].object.children[0].children.length;

    //   ) {
    //     rootControl.attach(
    //       intersects[0].object.children[0].children[attachmentIndex],
    //     );
    //   }
    //   intersects[0].object.children[0].attach(rootControl);
    // }

    if (intersects[0].object.name.charAt(0) === "u") {
      setControls3D("isUpper", true);
    } else {
      setControls3D("isUpper", false);
    }
    // if (previousSelectedTooth?.name != intersects[0].object.name) {
    // disableToothAnchor(previousSelectedTooth);
    // enableToothAnchor(intersects[0].object);
    // }

    // replace materials for tooth
    if (previousSelectedTooth) {
      previousSelectedTooth.material = previousSelectedTooth?.userData[
        "isLocked"
      ]
        ? lockedTeethMaterial
        : teethMaterial;
    }
    intersects[0].object.material = intersects[0].object?.userData["isLocked"]
      ? lockedTeethMaterial
      : selectedTeethMaterial;
    setControls3D("selectedTooth", intersects[0].object);
    previousSelectedTooth = intersects[0].object;
    calculateIPRToothForNegation(previousSelectedTooth, 1);
    calculateIPRToothForNegation(previousSelectedTooth, -1);

    if (tempName !== selectedTooth?.name) {
      //console.log(intersects[0].object);
      if (names.includes(intersects[0].object?.children?.[0]?.name)) {
        setControls3D(
          "selectedAttachmentType",
          intersects[0].object?.children?.[0]?.children?.[0]?.name,
        );
      } else {
        setControls3D("selectedAttachmentType", "");
      }
      // // Newly selected tooth's name is different from the old selected tooth's name
      // setControls3D("selectedAttachmentType", "");
      return;
    }

    //selecting attachment part
    if (intersects[0].object.children[0].children.length > 0) {
      return;
      for (
        let i = 0;
        i < intersects[0].object.children[0].children.length;
        i++
      ) {
        if (
          intersects[0].object.children[0].children[i].name.includes("att") &&
          selectedAttachmentType
          // intersects[0].object.children[0].name === selectedAttachmentType
        ) {
          const tooth = intersects[0].object;
          let selectedToothNum = tooth.name.split("_")[2].substring(1, 4);
          let action;
          if (attachmentArray[selectedToothNum]?.length > 0) {
            action = "replace";
          } else {
            action = "add";
          }

          let key = selectedToothNum.toString() + "_Movement";
          if (logs[key]) {
            const obj = Object.assign({}, logs[key]);
            delete logs[key];
            obj["attachment"] = {
              action: action,
              type: selectedAttachmentType,
            };
            logs[key] = obj;
          } else {
            logs[key] = {};
            logs[key]["attachment"] = {
              action: action,
              type: selectedAttachmentType,
            };
            logs[key][MovementTypes.MESIALDISTAL] = 0;
            logs[key][MovementTypes.BUCCALLINGUAL] = 0;
            logs[key][MovementTypes.EXTRUSIONINTRUSION] = 0;
            logs[key][MovementTypes.ROTATION] = 0;
            logs[key][MovementTypes.ANGULATION] = 0;
            logs[key][MovementTypes.INCLINATION] = 0;
            logs[key][MovementTypes.LEFTHINGE] = 0;
            logs[key][MovementTypes.RIGHTHINGE] = 0;
          }
          setLogs(logs);

          undoMovementList.push({
            actionType: "attachments",
            tooth: intersects[0].object,
            action: "move",
            attachmentName: intersects[0].object.children[0].children[i].name,
            relativePosition:
              intersects[0].object.children[0].children[i].position.clone(),
            relativeRotation:
              intersects[0].object.children[0].children[i].rotation.clone(),
          });
          setAutoSave();
          deleteAllAttachmentsFromTooth(
            intersects[0].object,
            logs,
            setLogs,
            false,
          );
          addAttachmentToTooth(
            names.indexOf(selectedAttachmentType),
            intersects[0],
          );
          clearRedoMovementList();
          return;
        }
      }
      return;
    } else {
      //adding attachment from the UI
      let tooth = intersects[0].object;
      if (selectedAttachmentType && tooth.name === tempName) {
        // add attachment to a tooth without attachment
        const attachment =
          attachmentsObjects[names.indexOf(selectedAttachmentType)];
        attachment.customID = attachmentIDCounter++;

        addAttachmentToTooth(attachment, intersects[0]);
        registerAddingAttachment(tooth, attachment);
        return;
      }
    }
  }
}
function registerAddingAttachment(tooth, attachment, isDragDropCall = false) {
  undoMovementList.push({
    actionType: "attachments",
    tooth: tooth,
    attachmentID: attachment.customID,
    attachmentName: attachment.name,
    relativePosition: attachment.position.clone(),
    relativeRotation: attachment.rotation.clone(),
    action: "add",
    continue: isDragDropCall,
  });
  let selectedToothNum = tooth.name.split("_")[2].substring(1, 4);
  let action;
  if (attachmentArray1[selectedToothNum]?.length > 0) {
    action = "add";
  } else {
    action = "add";
  }
  let key = selectedToothNum.toString() + "_Movement";
  if (!logs1[key]) {
    logs1[key] = {};
    logs1[key][MovementTypes.MESIALDISTAL] = 0;
    logs1[key][MovementTypes.BUCCALLINGUAL] = 0;
    logs1[key][MovementTypes.EXTRUSIONINTRUSION] = 0;
    logs1[key][MovementTypes.ROTATION] = 0;
    logs1[key][MovementTypes.ANGULATION] = 0;
    logs1[key][MovementTypes.INCLINATION] = 0;
    logs1[key][MovementTypes.LEFTHINGE] = 0;
    logs1[key][MovementTypes.RIGHTHINGE] = 0;
  }
  if (!logs1[key].hasOwnProperty("attachment")) {
    logs1[key]["attachment"] = {};
  }
  logs1[key]["attachment"][attachment.customID] = {
    action: action,
    type: attachment.name,
  };

  setLogs1(logs1);
  // setAutoSave1();
  clearRedoMovementList();
}
export function addRemoveAttachment(scene) {
  const loader = new GLTFLoader();
  Promise.all([
    loader.loadAsync("att_hbra.glb"),
    loader.loadAsync("att_vbra.glb"),
    loader.loadAsync("att_oblique.glb"),
    loader.loadAsync("att_extrusion.glb"),
    loader.loadAsync("att_biolane.glb"),
    loader.loadAsync("att_root_control.glb"),
    loader.loadAsync("att_rotational.glb"),
  ])
    .then(results => {
      results.forEach((model, i) => {
        model.scene.children[0].name = names[i];
        attachmentsObjects.push(model.scene.children[0]);
        // modelA.scene.children[0].scale.multiply(new THREE.Vector3(1, 1, -1));
        model.scene.children[0].material.transparent = true;
        model.scene.children[0].material.opacity = 0;
        model.scene.children[0].visible = false;
        // model.scene.children[0].position.copy(center);
        scene.add(model.scene.children[0]);
      });
    })
    .catch(err => {
      console.log(err);
    });
}
function disableToothAnchor(tooth) {
  console.log(tooth, "off");
  if (!tooth) {
    return;
  }
  for (let i = 0; i < tooth.children[3].children.length; i++) {
    if (tooth.children[3].children[i].name.includes("root")) {
      tooth.children[3].children[i].visible = false;
      console.log("Rooty off");
    }
  }
}
function enableToothAnchor(tooth) {
  for (let i = 0; i < tooth.children[3].children.length; i++) {
    if (tooth.children[3].children[i].name.includes("root")) {
      tooth.children[3].children[i].visible = true;
      console.log("Rooty on");
    }
  }
}
function addAttachmentToTooth(attachmentObject, clickRayCast) {
  if (!attachmentObject) {
    attachmentObject = deletedAtt;
  }
  let attachment, parentTooth;
  attachment = attachmentObject.clone();
  attachment.customID = attachmentObject.customID;
  parentTooth = clickRayCast.object;

  parentTooth.children[0].add(attachment);
  let permaVector = parentTooth.worldToLocal(clickRayCast.point.clone());
  attachment.position.copy(permaVector);
  attachment.lookAt(clickRayCast.point.sub(clickRayCast.face.normal));
  attachment.material = attachmentMaterial;
  attachment.visible = true;
  attachment.updateWorldMatrix();

  subscribeAttachmentToListener(attachment);
}

// delete all attachments on tooth
export function deleteAllAttachmentsFromTooth(tooth, saveAction = true) {
  for (let i = 0; i < tooth.children[0].children.length; i++) {
    if (tooth.children[0].children[i].name.includes("att")) {
      if (saveAction) {
        undoMovementList.push({
          actionType: "attachments",
          tooth: tooth,
          action: "remove",
          attachmentName: tooth.children[0].children[i].name,
          relativePosition: tooth.children[0].children[i].position.clone(),
          relativeRotation: tooth.children[0].children[i].rotation.clone(),
        });
      }
      removeListenersFrom(tooth.children[0].children[i]);
      return tooth.children[0].children[i].removeFromParent();
    }
  }
}
//
export function deleteAttachment(attachment, saveAction = true) {
  if (attachment.name.includes("att")) {
    const toothNum = attachment.parent.parent.name
      .split("_")[2]
      .substring(1, 4);
    if (saveAction) {
      undoMovementList.push({
        actionType: "attachments",
        tooth: attachment.parent.parent,
        action: "remove",
        attachmentID: attachment.customID,
        attachmentName: attachment.name,
        relativePosition: attachment.position.clone(),
        relativeRotation: attachment.rotation.clone(),
      });
    }

    if (
      logs1[toothNum + "_Movement"]?.attachment?.hasOwnProperty(
        attachment.customID,
      ) &&
      logs1[toothNum + "_Movement"].attachment[attachment.customID].type !==
      "_att"
    ) {
      // deleting new attachments
      delete logs1[toothNum + "_Movement"].attachment[attachment.customID];
    } else {
      // deleting existing attachment
      const key = toothNum + "_Movement";
      if (!logs1[key]) {
        logs1[key] = {};
        logs1[key][MovementTypes.MESIALDISTAL] = 0;
        logs1[key][MovementTypes.BUCCALLINGUAL] = 0;
        logs1[key][MovementTypes.EXTRUSIONINTRUSION] = 0;
        logs1[key][MovementTypes.ROTATION] = 0;
        logs1[key][MovementTypes.ANGULATION] = 0;
        logs1[key][MovementTypes.INCLINATION] = 0;
        logs1[key][MovementTypes.LEFTHINGE] = 0;
        logs1[key][MovementTypes.RIGHTHINGE] = 0;
      }
      if (!logs1[key].hasOwnProperty("attachment")) {
        logs1[key]["attachment"] = {};
      }
      logs1[key]["attachment"][attachment.customID] = {
        action: "remove",
        type: attachment.name,
      };
    }
    setLogs1(logs1);
    removeListenersFrom(attachment);
    return attachment.removeFromParent();
  }
}

export function prepareAttachment3DControlslisteners(upperLowerGroup) {
  for (let jawIndex = 0; jawIndex < 2; jawIndex++) {
    for (
      let toothIndex = 0;
      toothIndex < upperLowerGroup[jawIndex].children.length;
      toothIndex++
    ) {
      addEventListener(
        upperLowerGroup[jawIndex].children[toothIndex],
        "mousedown",
        raycasterInfo => {
          isReset = false;
          setControls3D1("activeControlTab", "teeth")
          if (!isLeftShiftDown) {
            setSelectedAtt(null);
            const tempName = raycasterInfo.object.name;

            if (tempName.charAt(0) === "u") {
              setControls3D1("isUpper", true);
            } else {
              setControls3D1("isUpper", false);
            }
            if (Array.isArray(previousSelectedTooth)) {
              previousSelectedTooth.forEach(tooth => {
                tooth.material = teethMaterial;
              });
            } else if (previousSelectedTooth) {
              previousSelectedTooth.material = previousSelectedTooth?.userData[
                "isLocked"
              ]
                ? lockedTeethMaterial
                : teethMaterial;
            }
            raycasterInfo.object.material = raycasterInfo.object?.userData[
              "isLocked"
            ]
              ? lockedTeethMaterial
              : selectedTeethMaterial;

            setControls3D1("selectedTooth", raycasterInfo.object);
            previousSelectedTooth = raycasterInfo.object;
            calculateIPRToothForNegation(previousSelectedTooth, 1);
            calculateIPRToothForNegation(previousSelectedTooth, -1);
          } else {
            setSelectedAtt(null);
            const tempName = raycasterInfo.object.name;

            if (tempName.charAt(0) === "u") {
              setControls3D1("isUpper", true);
            } else {
              setControls3D1("isUpper", false);
            }
            const isArray = Array.isArray(previousSelectedTooth);
            if (isArray) {
              previousSelectedTooth.forEach(tooth => {
                tooth.material = teethMaterial;
              });
            } else {
              if (previousSelectedTooth) {
                previousSelectedTooth.material = teethMaterial;
              }
            }
            if (
              !previousSelectedTooth ||
              (!isArray &&
                tempName.charAt(0) !==
                previousSelectedTooth?.name?.charAt(0)) ||
              (isArray &&
                tempName.charAt(0) !==
                previousSelectedTooth[0]?.name?.charAt(0))
            ) {
              raycasterInfo.object.material = raycasterInfo.object?.userData[
                "isLocked"
              ]
                ? lockedTeethMaterial
                : selectedTeethMaterial;
              setControls3D1("selectedTooth", raycasterInfo.object);
              previousSelectedTooth = raycasterInfo.object;
              secondPreviousTooth = undefined;
              calculateIPRToothForNegation(previousSelectedTooth, 1);
              calculateIPRToothForNegation(previousSelectedTooth, -1);
            } else {
              let selectedTeeth;
              if (Array.isArray(previousSelectedTooth)) {
                selectedTeeth = getAllTeethInRange(
                  secondPreviousTooth,
                  raycasterInfo.object,
                );
              } else {
                secondPreviousTooth = previousSelectedTooth;
                selectedTeeth = getAllTeethInRange(
                  previousSelectedTooth,
                  raycasterInfo.object,
                );
              }
              if (!selectedTeeth) {
                return;
              }
              selectedTeeth.forEach(tooth => {
                tooth.material = tooth?.userData["isLocked"]
                  ? lockedTeethMaterial
                  : selectedTeethMaterial;
                calculateIPRToothForNegation(tooth, 1);
                calculateIPRToothForNegation(tooth, -1);
              });
              setControls3D1("selectedTooth", selectedTeeth);
              previousSelectedTooth = selectedTeeth;
            }
          }
        },
      );
      addEventListener(
        upperLowerGroup[jawIndex].children[toothIndex],
        "mouseup",
        raycasterInfo => {
          if (deletedAtt) {
            if (deletedAtt.name !== "_att") {
              if (!deletedAtt.customID) {
                deletedAtt.customID = attachmentIDCounter++;
              }
              addAttachmentToTooth(null, raycasterInfo);
              registerAddingAttachment(
                raycasterInfo.object,
                deletedAtt,
                !isUIHold,
              );
              deletedAtt = null;
              setAutoSave1();
            } else {
              //undo
              console.log("undoing");
              undoRef();
              redoMovementList.pop();
              setAutoSave1();
              setControls3D1("isExistingAttachments", true);

              // console.log("toast for existing attachments");
            }
          }
        },
      );

      for (
        let attachmentIndex = 0;
        attachmentIndex <
        upperLowerGroup[jawIndex].children[toothIndex].children[0].children
          .length;
        attachmentIndex++
      ) {
        // give custom ID to existing attachments
        attachmentArray1[
          upperLowerGroup[jawIndex].children[toothIndex].name
            .split("_")[2]
            .substring(1)
        ][attachmentIndex].customID = attachmentIDCounter;

        upperLowerGroup[jawIndex].children[toothIndex].children[0].children[
          attachmentIndex
        ].customID = attachmentIDCounter++;

        subscribeAttachmentToListener(
          upperLowerGroup[jawIndex].children[toothIndex].children[0].children[
          attachmentIndex
          ],
        );
      }
    }
  }
}

function getAllTeethInRange(firstTooth, secondTooth) {
  if (firstTooth.parent !== secondTooth.parent) {
    return;
  }
  const parent = firstTooth.parent;
  const firstToothIndex = parent.children.indexOf(firstTooth);
  const secondToothIndex = parent.children.indexOf(secondTooth);

  return firstToothIndex < secondToothIndex
    ? parent.children.slice(firstToothIndex, secondToothIndex + 1)
    : parent.children.slice(secondToothIndex, firstToothIndex + 1);
}

export function subscribeAttachmentToListener(attachment) {
  addEventListener(attachment, "mousedown", raycasterInfo => {
    if (Controller.isHovered()) {
      return;
    }
    isReset = false;
    if (!isLeftShiftDown) {
      setSelectedAtt(raycasterInfo.object);
      resetSelectedTooth();
      setControls3D1("activeControlTab", "auxiliaries")
    }
  });

  addEventListener(attachment, "mousehold", raycasterInfo => {
    // update the cursor image1
    // select attachment
    if (Controller.isHovered()) {
      return;
    }
    if (raycasterInfo.object.name === "_att") {
      setControls3D1("selectedAttachmentType", "att_default");
    } else {
      setControls3D1("selectedAttachmentType", raycasterInfo.object.name);
    }
    setOrbitControlsEnabled(false);
    Controller.detach();
    deletedAtt = deleteAttachment(
      raycasterInfo.object.parent.name.includes("root")
        ? raycasterInfo.object.parent
        : raycasterInfo.object,
      true,
    );
    deletedAtt.position.copy(new THREE.Vector3(0, 0, 0));
    removeListenersFrom(raycasterInfo.object);
  });
}

export function resetSelectedTooth() {
  if (previousSelectedTooth) {
    if (Array.isArray(previousSelectedTooth)) {
      previousSelectedTooth.forEach(tooth => {
        tooth.material = teethMaterial;
      });
    } else {
      previousSelectedTooth.material = previousSelectedTooth?.userData[
        "isLocked"
      ]
        ? lockedTeethMaterial
        : teethMaterial;
    }
  }
  setControls3D1("selectedTooth", null);
  previousSelectedTooth = null;
}
